import ApiClient from '@lib/apiClient';

import { printApiError } from '@utils/Util';

export const fetchFabricFilterOptions = async (requestBody, queryParams) => {
	try {
		const { data } = await ApiClient.POST('fabricFilterOptions', requestBody, queryParams);
		return data;
	} catch (e) {
		printApiError(e);
	}
};

export const handleGetFabricCategoryList = async (param = '') => {
	try {
		const query = `?fabricType=${param}`;
		const { data } = await ApiClient.GET('getFabricCategory', param ? query : '');
		let categories = data?.map((item) => {
			return {
				...item,
				id: item.id,
				value: item.name
			};
		});
		return categories;
	} catch (error) {
		printApiError(error);
	}
};

export const markMaterialAsLowQty = async (materialIdList) => {
	try {
		const { data } = await ApiClient.POST(
			'markAsLowQty',
			'',
			`?materialIdList=${materialIdList.join(',')}`
		);
		return data;
	} catch (e) {
		printApiError(e);
	}
};

export const addColorsToMaterial = async (requestBody, materialId, colorGroupIds, colorType) => {
	try {
		const { data } = await ApiClient.POST(
			'materialAction',
			requestBody,
			`${materialId}/color/add?colorType=${colorType}&colorGroupIds=${colorGroupIds}`
		);
		return data;
	} catch (e) {
		printApiError(e);
	}
};

export const undoMaterialWastage = async (id) => {
	try {
		const { data } = await ApiClient.PATCH('undoInventoryWastage', '', id);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const getFabricByDescription = async (description, selectedBalance, selectedCountry) => {
	try {
		let params = `?search=${description}&inventoryFilterType=${selectedBalance}`;
		if (selectedCountry !== null) {
			params += `&inventoryCountryId=${selectedCountry}`;
		}
		const { data } = await ApiClient.GET('serchFabricByDescription', params);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const restrictMaterialBooking = async (receivedLogId, isReserved) => {
	try {
		const params = `/${receivedLogId}?isReserved=${isReserved}`;
		const data = ApiClient.PUT('restrictBooking', {}, params);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const getFabricReferenceList = async (params) => {
	try {
		const { data } = await ApiClient.POST(`getSuppliersMaterials`, params);
		const pairFabrics = data?.data.map((fabric) => {
			return {
				...fabric,
				value: fabric?.referenceNumber,
				id: fabric?.materialId
			};
		});
		return pairFabrics;
	} catch (e) {
		printApiError(e);
	}
};

export const getMaterialHistory = async (productId) => {
	try {
		const { data } = await ApiClient.GET('getProductMaterialHistory', `${productId}/material-history`);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const getPairMaterialList = async (materialIds, materialTypeList) => {
	try {
		const { data } = await ApiClient.GET(
			'getPairMaterials',
			`?materialIds=${materialIds}&materialTypeList=${materialTypeList}`
		);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const getPairMaterialListForProduct = async (id) => {
	try {
		const { data } = await ApiClient.GET('getPairMaterialsForProduct', `?productId=${id}`);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const addPairMaterial = async (primaryMaterialId, pairMaterialId, pairType) => {
	try {
		const { data } = await ApiClient.POST(
			'addPairMaterial',
			{},
			`${primaryMaterialId}/pair/${pairMaterialId}?pairType=${pairType}`
		);
		return data;
	} catch (e) {
		printApiError(e);
	}
};

export const deletePairMaterial = async (primaryMaterialId, pairMaterialId) => {
	try {
		const { data } = await ApiClient.DELETE(
			'deletePairMaterial',
			{},
			`${primaryMaterialId}/pair/${pairMaterialId}`
		);
		return data;
	} catch (e) {
		printApiError(e);
	}
};
